import {FilterRange} from './group-search';
import { PostType } from './post-overview';

export class DiscoverInfluencer {
  channels: any[];
  companyId: number;
  country: any;
  description: string;
  domain: string;
  engagement: number;
  favouriteTopics: Array<string>;
  topTopics: Array<any>;
  gender: any;
  groupId: number;
  impact: number;
  impression: number;
  influencerId: number;
  influencerName: string;
  keywords: any;
  language: any;
  mentions: any[];
  numberOfFollowers: number;
  numberOfPosts: number;
  profilePicture: string;
  reach: number;
  relativePath: string;
  topMentions: any[];
  urlDate: number;
}

export class DiscoverPost {
  engagement: number;
  fullUrl: string;
  imageUrl: string;
  videoUrl: string;
  impact: number;
  interaction: number;
  impression: number;
  influencerId: number;
  influencerName: string;
  mentions: string[];
  platform: any;
  projects: any;
  publishedDate: number;
  reach: number;
  relativePath: string;
  title: string;
  urlHash: string;
  story: boolean;
  completed: boolean;
  video: boolean;
  mediaWidth: number;
  mediaHeight: number;
  channel: any;
  channelId: number;
  imageWidth: number;
  imageHeight: number;
  postType: PostType;
}

export class AudienceFilter {
  name: string;
  value: string[] = [];
  range: FilterRange;
}

export class DiscoverAudienceFilter {
  gender: AudienceFilter;
  age: AudienceFilter;
  country: AudienceFilter;
  constructor() {
    this.gender = new AudienceFilter();
    this.age = new AudienceFilter();
    this.country = new AudienceFilter();
  }
}

export class DiscoverInterestFilter {
  topicPercentage: AudienceFilter;
  topIndustries: AudienceFilter;
  constructor() {
    this.topicPercentage = new AudienceFilter();
    this.topIndustries = new AudienceFilter();
  }
}



// WEBPACK FOOTER //
// ./src/models/discover.ts